export default "__VITE_ASSET__vkFg50f0__"